import { defineComponent as _defineComponent } from 'vue'
import BaseButton from "@/components/buttons/BaseButton.vue";

import {
  computed,
  onMounted,
  PropType,
  ref,
  unref, watch,
} from "vue";

import {
  VatDetail,
} from "@/scripts/Common";

import {
  VatType,
} from "@/Enums";

import {
  useI18n,
} from "@/composables/useI18n";

import {
  createEmptyVatDetail,
} from "@/scripts/Common/helpers/vatDetailHelpers";

import {
  hasCorrectDecimalsCount, isNotArrayOrEmpty,
  isNumberAndGreaterOrEqualAsMinValue,
  isNumberAndSmallerOrEqualAsMaxValue,
} from "@/scripts/Common/validators/defaultValidator";

import {
  MAX_DECIMALS_VAT_RATE,
  MAX_VAT_RATE,
  MIN_VAT_RATE,
} from "@/components/settings/scripts/VatDetails/constraints";

import {
  useDateStringLocalization,
} from "@/composables/formatDateStringWithLocalization";

import {
  DateFormats
} from "@/scripts/Common/DateFormats";

import moment from "moment";

import {
  findActiveVatDetail,
} from "@/components/settings/scripts/VatDetails/vatDetailHelpers";

import {
  getMinDateRestriction,
} from "@/scripts/Common/HelperFunctions";

import DateInput from "@/components/base/DateInput.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'VatDetailEdit',
  props: {
  vatDetails: {
    required: true,
    type: Array as PropType<VatDetail[]>,
  },
  vatType: {
    required: true,
    type: String as PropType<VatType>
  },
  hasEditRights: {
    required: false,
    type: Boolean as PropType<boolean>,
    default: true,
  },
  label: {
    required: false,
    type: String as PropType<string | undefined>,
    default: undefined
  },
  validateData: {
    required: false,
    type: Boolean as PropType<boolean>,
    default: false
  }
},
  emits: [
  'addVatDetail',
  'removeVatDetail',
  "onValidChange"
],
  setup(__props, { expose, emit: emits }) {

const props = __props;

const {
  t,
} = useI18n();

const {
  localizeDateString
} = useDateStringLocalization();





const showAddVatDetailDialog = ref(false);

const activeVatDetail = findActiveVatDetail(props.vatDetails);

const valid = ref(!props.validateData);

const internalValid = ref(false);

const addVatRateForm = ref();

const vatDetailToAdd = ref(createEmptyVatDetail());

const vatDetailList = computed(() => props.vatDetails as VatDetail[]);

const vatDetailsEmpty = computed(() => isNotArrayOrEmpty(vatDetailList.value))

const title = computed(() => !props.label ? t('default_headline') : props.label)

const validate = () => {
  valid.value = !props.validateData || !vatDetailsEmpty.value;
}

const validateInternalForm = () => {
  addVatRateForm.value?.validate();
}

const onHandleAddVatDetail = () => {
  vatDetailToAdd.value.vatType = props.vatType;
  vatDetailToAdd.value.validFrom = moment().add(1, "days").format(DateFormats.ISO8601_LONG);
  showAddVatDetailDialog.value = true;
  validateInternalForm();
}

const isActiveVatDetail = (vatDetail: VatDetail) => {
  if (!activeVatDetail) return false;

  return vatDetail.id === activeVatDetail.id;
}

const canDelete = (vatDetail: VatDetail) => {
  const validFromDate = moment(vatDetail.validFrom).format(DateFormats.YEAR_MONTH_DAY);
  const tomorrowDate = moment().add(1, 'days').format(DateFormats.YEAR_MONTH_DAY);

  return validFromDate >= tomorrowDate;
}

const clearVatDetailToAdd = () => vatDetailToAdd.value = createEmptyVatDetail();

const onHandleCancelAddVatDetailDialog = () => {
  showAddVatDetailDialog.value = false;
  clearVatDetailToAdd();
}
const onHandleConfirmAddVatDetailDialog = () => {
  emits('addVatDetail', unref(vatDetailToAdd));
  showAddVatDetailDialog.value = false;
  clearVatDetailToAdd();
}

const onHandleRemoveVatDetail = (vatDetail: VatDetail) => emits('removeVatDetail', unref(vatDetail));

watch(vatDetailList, () => {validate()}, {deep: true});
watch(valid, () => {
  emits('onValidChange', unref(valid))
})

onMounted(() => {
  validate();
  emits('onValidChange', unref(valid))
})

expose(
  validate
)

return { __sfc: true,t, localizeDateString, emits, props, showAddVatDetailDialog, activeVatDetail, valid, internalValid, addVatRateForm, vatDetailToAdd, vatDetailList, vatDetailsEmpty, title, validate, validateInternalForm, onHandleAddVatDetail, isActiveVatDetail, canDelete, clearVatDetailToAdd, onHandleCancelAddVatDetailDialog, onHandleConfirmAddVatDetailDialog, onHandleRemoveVatDetail, BaseButton, hasCorrectDecimalsCount, isNumberAndGreaterOrEqualAsMinValue, isNumberAndSmallerOrEqualAsMaxValue, MAX_DECIMALS_VAT_RATE, MAX_VAT_RATE, MIN_VAT_RATE, DateFormats, getMinDateRestriction, DateInput }
}

})